var translate = function (id, params) {
    if (params === void 0) { params = {}; }
    return Translator.trans(id, params);
};
export default translate;
